//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'
import indexTop from './components/indexTop'
import indexFooter from './components/indexFooter'
import { MainApi } from '@/api'
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import PullDown from '@better-scroll/pull-down'
import qrDialog from './components/Dialog'
// import Common from './../common/js/common'

export default {
  name: 'Index',
  mixins: [mixin],
  components: {
    indexTop,
    indexFooter,
    qrDialog,
  },
  data() {
    return {
      isQrShows: false,
      qrImg: '',
      // better-scroll滚动组件对象
      bs: null,
      scrollTips: '上拉展示更多',
      isMoreData: true,
      isScrollAllow: true,
      shouyiText: '预计每日收益（元）',
      isno: false,
      listArr: [],
      searchForm: {
        ProvinceId: '',
        BankType: '',
        RiskType: '',
        page: 1,
        pageSize: 10,
        InvestmentDays: '',
        money: '',
        order: 'AnnualizedIncomeMin',
        sort: 'desc',
      },
    }
  },
  created() {
    this.getListFn()
    // this.scrollBottomFn()
  },
  mounted() {
    this.initBScroll()
  },
  beforeDestroy() {},
  methods: {
    getChangeCloseFn() {
      this.isQrShows = false
    },
    showDialogQrFn() {
      this.isQrShows = true
    },
    getListFn() {
      if (this.searchForm.page == 1) {
        this.scrollTips = '上拉展示更多'
        this.isMoreData = true
      }

      if (!this.isMoreData) {
        this.scrollTips = '没有了~'
        this.bs.closePullUp()
        return false
      }

      this.$vux.loading.show({
        text: '加载中',
      })
      MainApi.getSearchApi(this.searchForm)
        .then(data => {
          this.$vux.loading.hide()
          this.isScrollAllow = true
          if (data.Status === 200) {
            // console.log('搜索数据 ', data)

            if (this.searchForm.page < 2) {
              // this.isMoreData = true
              this.listArr = data.Result.data
              this.$nextTick(() => {
                this.bs.refresh()
              })
            } else {
              if (!data.Result.data.length) {
                // this.$vux.toast.text('没有更多数据了', 'top')
                this.scrollTips = '没有了~'
                this.isMoreData = false
                this.bs.closePullUp()
                return false
              }

              this.listArr = this.listArr.concat(data.Result.data)
              this.$nextTick(() => {
                this.bs.refresh()
              })
              this.scrollTips = '上拉展示更多'
            }
            if (data.Result.count > this.listArr.length) {
              this.bs.openPullUp()
              this.scrollTips = '上拉展示更多'
            } else {
              this.scrollTips = '没有了~'
            }
          } else {
            this.$vux.toast.text(data.Result.ErrorMsg, 'top')
          }
        })
        .catch(() => {
          this.$vux.loading.hide()
        })
    },
    initBScroll() {
      BScroll.use(Pullup)
      BScroll.use(PullDown)

      this.bs = new BScroll(this.$refs.scroll, {
        scrollY: true, // 开启纵向滚动
        click: true, // 允许点击事件
        eventPassthrough: 'horizontal', // 保留横向的原生滚动
        bounce: {
          // 边缘回弹
          top: false,
          bottom: true,
        },
        probeType: 3, // 实时派发 scroll 事件
        pullUpLoad: true, // 开启上拉加载
        pullDownRefresh: false, // 开启下拉刷新
      })
      // console.log('this.bs', this.bs)

      this.bs.on('pullingUp', () => {
        this.scrollTips = '正在加载...'
        this.isScrollAllow = false
        this.searchForm.page++
        // this.$nextTick(() => {
        this.getListFn()
        this.bs.finishPullUp()
        // })
      })
    },
    // scrollBottomFn() {
    //   window.onscroll = () => {
    //     if (this.$route.name === 'Index' && this.listArr.length) {
    //       let scrollTop =
    //         document.documentElement.scrollTop || document.body.scrollTop
    //       let windowHeight =
    //         document.documentElement.clientHeight || document.body.clientHeight
    //       let scrollHeight =
    //         document.documentElement.scrollHeight || document.body.scrollHeight
    //       let num = 0
    //       if (scrollTop + windowHeight == scrollHeight) {
    //         num++
    //         if (num === 1 && this.isScrollAllow) {
    //           this.scrollTips = '正在加载...'
    //           this.isScrollAllow = false
    //           this.searchForm.page++
    //           // this.$nextTick(() => {
    //           this.getListFn()
    //           // })
    //         }
    //       }
    //     }
    //   }
    // },
    // getChangeFilterVal(val) {
    //   //从子组件获取值
    //   this.searchForm = { ...this.searchForm, ...val }
    //   this.searchForm.page = 1
    //   this.getListFn()
    // },
    getChangeSearchVal(val) {
      // console.log('val.InvestmentDays', val.InvestmentDays)

      // if (val.InvestmentDays !== '') {
      //   this.shouyiText = '预计收益（元）'
      // }else{

      // }
      //从子组件获取值
      this.searchForm = { ...this.searchForm, ...val }
      this.shouyiText = this.searchForm.InvestmentDays
        ? '预计收益（元）'
        : '预计每日收益（元）'
      this.searchForm.page = 1
      this.bs.finishPullUp()
      this.bs.closePullUp()
      console.log('this.bs', this.bs)

      this.bs.scrollTo(0, 0, 0)
      this.getListFn()
    },
    investBtnFn(type, url) {
      if (type == 1) {
        this.qrImg = url
        this.showDialogQrFn()
      } else {
        window.location.href = url
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/Index.vue